import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// 🛡️ Global Error Suppression for MetaMask and Extension conflicts
// This prevents external browser extension errors from triggering the React error overlay
const suppressExtensionErrors = () => {
  const originalError = console.error;
  
  // Suppress console errors
  console.error = (...args) => {
    const errorStr = args.join(' ');
    if (
      errorStr.includes('MetaMask') || 
      errorStr.includes('chrome-extension://') || 
      errorStr.includes('extension')
    ) {
      return;
    }
    originalError.apply(console, args);
  };

  // Suppress runtime errors from taking down the UI
  window.addEventListener('error', (event) => {
    if (
      event.message?.includes('MetaMask') || 
      event.filename?.includes('chrome-extension') ||
      event.error?.stack?.includes('chrome-extension')
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });

  // Suppress unhandled rejections
  window.addEventListener('unhandledrejection', (event) => {
    if (
      event.reason?.message?.includes('MetaMask') || 
      event.reason?.stack?.includes('chrome-extension')
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });
};

suppressExtensionErrors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);